import React from "react"
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { inject, observer } from 'mobx-react';

interface IAppOverlayProps {
    sessionStore: any,
}

interface IAppOverlayState {
    something: any
}

@inject("sessionStore")
@observer
class AppOverlay extends React.Component<IAppOverlayProps, IAppOverlayState> {
    
    hideModal = () => {
        const {sessionStore} = this.props;
        const { overlayModal } = sessionStore;
        sessionStore.hideOverlay()
    }

  render() {
    const {sessionStore} = this.props;
    const { overlayModal } = sessionStore;
    const overlayComp = (<Modal
        isOpen={overlayModal.show}
        toggle={this.hideModal}
        className="modal-dialog-centered"
    >
        {overlayModal.blocking ? null : 
            <ModalHeader toggle={this.hideModal}></ModalHeader>
        }
        <ModalBody>
            <p>{overlayModal.message}</p>
            <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                {overlayModal.component}
            </div>
        </ModalBody>
    </Modal>)
    return <React.Fragment>
        { overlayComp  }
    </React.Fragment>
  }
}
export default AppOverlay
